import React, { useEffect, useState } from 'react';
import {
	// AxisLabel,
	Clear,
	ColorSwatch,
	LineStyle,
	Measure,
} from './chart-components/drawing';
import {
Font,
FontStyle,
} from './chart-components/text';

import { MenuSelect } from './chart-components';
import { MeasureOptions } from './chart-components/drawing/Measure';
import { IOptions } from './chart-components/MenuSelect';
import { IColorColor } from './chart-components/modals/StudyModal';

const CIQ = (window as any).CIQ;

export interface IEventListenerCallbackObj {
	stx: any,
	symbol: string,
	symbolObject: any,
	layout: any,
	drawings: any
}

const drawingTools = CIQ.Drawing.getDrawingToolList({ retracement: true });
const toolsArray = Object.keys(drawingTools).map((key) => drawingTools[key]).sort();
const tools = toolsArray.map((tool) => {
	return { label: tool };
});
function toTitleCase(option: IOptions) {
	if (option && option.label) {
		return option.label.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}
	return ''
}

export const DrawIQ: React.FunctionComponent<{ciq: any, showDrawingToolbar: boolean}> = ({ ciq, showDrawingToolbar }) => {
	// const [currentToolHasLabels, setCurrentToolHasLabels] = useState(false);
	const [toolTitle, setToolTitle] = useState('Select Tool');
	const [selectedTool, setSelectedTool] = useState<MeasureOptions>('Callout');
	const [selectedToolParams, setSelectedToolParams] = useState<any>({});
	// const [isPickingDrawColor, setIsPickingDrawColor] = useState(false);

	const [canClear, setCanClear] = useState(false);

	// const [lineColor, setLineColor] = useState('');
	// const [bold, setLineColor] = useState('');
	// const [italic, setLineColor] = useState('');
	// const [family, setLineColor] = useState('');
	// const [lineColor, setLineColor] = useState('');
	// const [lineColor, setLineColor] = useState('');
	useEffect(() => {
		if (ciq) {
			if (showDrawingToolbar) {
				ciq.changeVectorType(selectedTool.toLowerCase())
			} else {
			// ensure we turn the drawing off
			ciq.changeVectorType(null)
			}
		}
	}, [ciq, showDrawingToolbar, selectedTool])
	useEffect(() => {
		if (ciq) {
			ciq.addEventListener('drawing', (obj: IEventListenerCallbackObj) => {
				// TODO
				// tslint:disable-next-line:no-console
				if (obj.drawings && obj.drawings.length > 0) {
					setCanClear(true)
				} else {
					setCanClear(false)
				}
			})
		}
	}, [ciq])

	const changeVectorStyle = (styleType: string, style: any) => {
		switch (styleType) {
			case 'bold':
				ciq.currentVectorParameters.annotation.font.weight = !style.bold ? 'bold' : 'normal';
				break;
			case 'italic':
				ciq.currentVectorParameters.annotation.font.style = !style.italic ? 'italic' : 'normal';
				break;
			case 'family':
				ciq.currentVectorParameters.annotation.font.family = style.family;
				break;
			case 'size':
				ciq.currentVectorParameters.annotation.font.size = style.size + 'px';
				break;
			default:
				break;
		}
	};
	const setColor = (color: string | IColorColor, type: string, name: string | undefined) => {
		if (type === 'line') {
			ciq.currentVectorParameters.currentColor = CIQ.hexToRgba('#' + color);
			setSelectedToolParams({
				...selectedToolParams,
				color: CIQ.hexToRgba('#' + color),
			});
		} else if (type === 'fill') {
			ciq.currentVectorParameters.fillColor = CIQ.hexToRgba('#' + color);
			setSelectedToolParams({
				...selectedToolParams,
				fillColor: CIQ.hexToRgba('#' + color),
			});
		}
	};

	const changeFontStyle = (type: string) => {
		// setFontStyle(type);
		// changeVectorStyle(type, { bold: fontStyle.bold, italic: fontStyle.italic });
	};

	const changeFontFamily = (family: string) => {
		// setFontFamily(family);
		ciq.currentVectorParameters.annotation.font.family = family;
		setSelectedToolParams({
			...selectedToolParams,
			font: {
				...selectedToolParams.font,
				family,
			},
		});
		changeVectorStyle('family', { family });
	};

	const changeFontSize = (size: string) => {
		changeVectorStyle('size', { size: Number(size) });
	};

	const changeLineStyle = (weight: number, pattern: string) => {
		ciq.currentVectorParameters.lineWidth = weight;
		ciq.currentVectorParameters.pattern = pattern;
		setSelectedToolParams({
			...selectedToolParams,
			pattern,
			weight,
		});
		// setLineParams(weight, pattern);
		// changeVectorLineParams(weight, pattern);
	};

	const changePickerState = (isOpen: boolean) => {
		// setIsPickingDrawColor(isOpen);
	};

	const changeTool = (tool: any, toolParams: any) => {
		setSelectedTool(tool.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()))
		setSelectedToolParams(toolParams);
	};

	const changeVectorParams = (tool: any) => {
		const style = ciq.canvasStyle('stx_annotation');
		if (style) {
			ciq.currentVectorParameters.annotation.font.size = style.size;
			ciq.currentVectorParameters.annotation.font.family = style.family;
			ciq.currentVectorParameters.annotation.font.style = style.style;
			ciq.currentVectorParameters.annotation.font.weight = style.weight;
		}
	};

	const setTool = (tool: any) => {
		if (ciq === null) {
			return;
		}

		if (tool === 'callout' || tool === 'annotation') { // no need to do this every time
			// Sync the defaults for font tool
			const style = ciq.canvasStyle('stx_annotation');
			ciq.currentVectorParameters.annotation.font.size = style.fontSize;
			ciq.currentVectorParameters.annotation.font.family = style.fontFamily;
			ciq.currentVectorParameters.annotation.font.style = style.fontStyle;
			ciq.currentVectorParameters.annotation.font.weight = style.fontWeight;
		}

		const toolParams = CIQ.Drawing.getDrawingParameters(ciq, tool.label);
		changeTool(tool.label, toolParams);
		changeVectorParams(tool.label);
		setToolTitle(toTitleCase(tool));
	};

	const clear = () => {
		ciq.clearDrawings(true)
	};

	if (showDrawingToolbar) {
		return (
			<div className="toolbar">
				<MenuSelect
					hasButtons={false}
					options={tools}
					keyName="tool"
					handleOptionSelect={setTool}
					menuId="toolSelect"
					title={toolTitle}
					labelNeedsTransform={true}
					labelTransform={toTitleCase} />
				<span>
					<div className="drawingParameters">
						<ColorSwatch name="Line" type="line" top={0} setColor={setColor} color={selectedToolParams.color} changeState={changePickerState} />
						<ColorSwatch name="Fill" type="fill" top={0} setColor={setColor} color={selectedToolParams.fillColor} changeState={changePickerState} />
						<LineStyle linePattern={selectedToolParams.pattern} lineWidth={selectedToolParams.lineWidth} onClick={changeLineStyle} />
						{
							selectedToolParams && selectedToolParams.font ?
							<React.Fragment>
								<FontStyle
									fontStyle={{ bold: false, italic: false }}
									fontOptions={selectedToolParams.font}
									toggleFontStyle={changeFontStyle} />
								<Font
									fontSize={selectedToolParams.font.size}
									fontFamily={selectedToolParams.font.family}
									onFamilyClick={changeFontFamily}
									onSizeClick={changeFontSize} />

							</React.Fragment>
								:
								<React.Fragment />
						}
						<Measure selectedTool={selectedTool} />
						{/* <AxisLabel hasLabels={currentToolHasLabels} /> */}
					</div>
					<div className="undoSection">
						<Clear clear={clear} canClear={canClear} />
					</div>
				</span>
			</div>
		);
	}
	return (<span />);
};